module.exports = __webpack_public_path__ + "img/index-banner.5aafb4ce.png";